import { render, staticRenderFns } from "./TableOnlyMatrix.vue?vue&type=template&id=3257a74a&"
import script from "./TableOnlyMatrix.vue?vue&type=script&lang=js&"
export * from "./TableOnlyMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports